import { MyGrades } from './../pages/mygrades';
import { ICourseFilters } from './../components/user-home_my_courses';
import {
    IModLoginState,
    UserType,
    IUserPermission,
    IUserCustomPersmission
} from '../pages/login.d';
import { ILoginAnnouncementModel } from '../pages/announcement';
import * as actionTypes from './assignment';
import * as actionTypeDocument from '../../models/action/document';
import * as actionTypeInformationNote from '../../models/action/informationNote';
import * as actionTypeExam from './exam';
import * as actionTypeLti from '../../models/action/lti';
import * as actionTypeCalendar from '../../models/action/calendar';
import * as actionTypeProject from '../../models/action/project';
import * as actionTypeElesson from '../../models/action/elesson';
import * as actionTypeVirtualClass from '../../models/action/virtualClass';
import * as actionTypeLink from '../../models/action/link';
import * as actionTypeSurvey from '../../models/action/survey';
import * as actionTypeEnrollment from '../../models/action/enrollment';
import * as actionTypeProfile from '../../models/action/profile';
import * as actionTypeReport from '../../models/action/reports';
import * as actionTypeVideo from '../../models/action/video';
import * as actionTypeForum from '../../models/action/forum';
import * as actionTypeExamSession from '../../models/action/examSession';
import * as actionTypeAddExamSession from '../../models/components/add-exam-sessions';
import * as actionTypeQuestion from '../../models/components/questions';
import * as actionTypeQrPolling from '../../models/components/qrPolling';
import { IActivityCard } from '../../models/components/activity-card';
import {
    ICourseStudentListTabState,
    IFilterStudent
} from '../../models/components/course-student-list';
import * as userAddModalTypes from '../../models/components/add-activity-project-content';
import {
    IFilePagedQuery,
    IFileView
} from '../../models/components/course-files';
import { IActivityStatsModel } from '../../models/components/activity-report-modal';
import { IPagedQuery } from '../../models/components/paginate';
import {
    IAssignmentGradeInformationModel,
    IAssignmentGradeStudentItem
} from '../../models/components/assignment-grade-modal';
import { SurveyQuestionType } from '../enums/SurveyQuestionType';
import { IUserPreferenceModel } from '../pages/IUserPreferenceModel';
import { IUserHomeAnnouncementModel } from '../pages/IUserHomeAnnouncementModel';
import { ActivityCompletionType } from '../enums/activityCompletionType';
import { ActivityType } from '../components/lesson-upcoming-activity';
import { IMyActivityStats } from './coursePage';
import { ILessonPageClassInformation } from '../pages/coursePage';
import { IConversation } from './forum';
import { ICreateForumData } from '../components/create-forum';
import { IForumMessage } from '../components/forum-message';
import { Guid } from 'guid-typescript';
import { IAnnouncement } from './announcement';
import ICourseContentTermWeeks from '../../models/components/course-content-termweeks';
import { ExamEntryDateType } from '../enums/ExamEntryDateType';
import { ExamScoringType } from '../enums/ExamScoringType';
import { IPagedQueryS } from '../components/paginate';
import { ActivityTypeEnums } from '../enums/ActivityType';
import { IActivityFilters } from '../../models/action/coursePage';
import { IAddedActivityFileView, IAddedAssignmentFileView, IDeletedFileView } from '../../models/pages/addedActivityFiles';
import { CourseDefaultViewType } from '../enums/CourseDefaultViewType';
import { INotification } from './notification';
import { IMyFiles } from '../pages/files';
import { ISetQrCodeForAttendance } from './qrPolling';

export interface IAuthInformation {
    access_token: string | null;
    refresh_token: string | null;
    expire_date: Date | null;
    auth_url: string | null;
}

export interface IAction {
    type: string;
    timestamp: number;
    spinnerId?: string | null;
    spinnerIds?: any;
    spinnerType?: 'get' | 'set';
    callback?: (value: any) => void;
}

export interface ISetActivityType extends IAction {
    activityType?: ActivityType | null;
    activityId?: string | null;
}

export interface ISetActivityPassive extends IAction {
    activityId: string | null;
    status: any;
}
export interface INotificationAction extends IAction {
    notificationType?: 'info' | 'success' | 'error' | 'warning';
    position?: 'default' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
    timeOut?: number | 'fixed';
    text: string;
    title?: string;
    timeout?: number;
    onClick?: any;
}

export interface IGraylogAction extends IAction {
    messageData?: any | null;
    userGuid?: string;
    userFullName?: string;
}

interface IMainMenuState extends IAction {
    mainMenu: Array<{ staticLink: string; name: string; url: string }>;
    mainMenuIsLoading: boolean;
    mainMmenuCourseContentIsLoaded: boolean;
    courseMenuPanelItemsIsLoaded: boolean;
    menuPanelItems: Array<{ name: string; type: number }>;
    tabActiveStatus: number;
    courseSubNavigationTabParam: string;
    mainMenuCourseContent: Array<
        {
            logoUrl: string;
            name: string;
            progress: string;
            teachers: string;
            classId: string;
            courseId: string;
            endDate: string;
            startDate: string;
        }
    >;
}

interface ILoginState {
    currentPage: string;
    trackingGuid: string;
    organizationId: number;
    organizationName: string;
    abbreviation: string;
    headerText: string;
    footerText: string;
    logoPath: string;
    backgroundPath: string;
    organizationLogo: string;
    backgroundColor: string;
}

export interface ISelectOption {
    label: string;
    value: any;
}

/* App states */
interface IAppModuleStates {
    login: IModLoginState;
}

export interface IAppState {
    login: {
        login: {
            currentPage: string;
            trackingGuid: string;
            organizationId: number;
            organizationName: string;
            abbreviation: string;
            headerText: string;
            footerText: string;
            logoPath: string;
            backgroundPath: string;
            organizationLogo: string;
            headerBackgroundImage: string;
            backgroundColor: string;
            forgotPasswordURLLink: string;
            requiresQuestionAndAnswer: boolean;
            forgotPasswordEnable: string;
            forgotMyPassword: any;
            forgotPasswordUrlRecover: string;
            haveUser: boolean;
            passwordSecurtiyQuestion: string;
            resetPasswordLoading: true;
            isQuestion: '';
            myForgotPasswordAnswerStatus: boolean;
            myForgotPasswordQuestionLoading: boolean;
            recoveryPasswordToken: string;
            notFoundToken: boolean;
            expiredToken: boolean;
            newPasswordLoading: boolean;
            minPasswordLength: number;
            passwordStrength: string;
            alphaNumericLength: number;
            newPasswordSaveStatus: boolean;
            defaultCulture: string;
            forceChangePassword: boolean;
            minNonAlphanumericLength: number;
            requisiteMinPasswordLength: number;
            isAlmsPlusLoginPage: boolean | null;
            googleCaptchaSiteKey: string;
            moduleItems: any;
            isThereTwoFactorAuth: boolean;
            twoFactorEmail: string;
        };
        identitiy: {
            timeZone: any;
            userId: string;
            firstName: string;
            lastName: string;
            fullName: string;
            isLogin: boolean;
            email: string;
            userName: string;
            userType: UserType;
            loginPermission: Array<IUserPermission>;
            profileImagePath: string;
            isSimulate: boolean;
            customLoginPermission: Array<IUserCustomPersmission>;
            culture: string;
            clusterType: string;
            organizationId: int;
            forceChangePassword: boolean;
            programName: string;
        };
        loginCulture: string;
        loginData: {
            username: string;
            password: string;
            loginCulture: string;
            googleCaptchaToken: string;
            loginToken: string;
            isExternal: boolean;
        };
        twoFactorVerificationError: string;
    };
    mainMenuRoot: {
        mainMenuIsLoading: boolean;
        timestamp: number;
        type: string;
        mainMenu: Array<{ staticLink: string; name: string; url: string }>;
        courseSubNavigationTabParam: string;
        menuPanelItems: Array<{ name: string; type: number }>;
        activityAddType: ActivityType | null;
        activityAddId: string | null;
        tabActiveStatus: number;
        courseMenuPanelItemsIsLoaded: boolean;
        mainMenuCourseContent: Array<
            {
                teachers: string;
                name: string;
                logoUrl: string;
                progress: string;
                classId: string;
                courseId: string;
                endDate: string;
                startDate: string;
            }
        >;
        mainMmenuCourseContentIsLoaded: boolean;
    };
    coursePage: {
        classes: {
            coursePageActivityId: string,
            classes: Array<any>
        };
        isPassiveButton: boolean;
        isGettingWeeks: boolean;
        isShowActivityAdd: boolean;
        coursePageClassId: string;
        courseActivityClassId: string;
        coursePageActivityId: string;
        actId: string | null | undefined;
        activityIdAfterAdd: string | null | undefined;
        ActivityReportDetail: ISetActivtyReportDetails | null;
        weekOrUnitId: string | null | undefined;
        coursePageclassInformation: ILessonPageClassInformation | null;
        lessonHeaderIsLoaded: boolean;
        activityProgressIsLoaded: boolean;
        announcementIsLoaded: boolean;
        currentWeekActivitiesIsLoaded: boolean;
        activityProgressRecords: Array<any>;
        isTriggerGetActivities: boolean;
        isClickedWeek: boolean;
        getMoreActivities: boolean;
        resetShowMoreCount: boolean,
        searchClassId?: string;
        searchCourseId?: string;
        searchActivityId?: string;
        searchTermWeekId?: string;
        courseSortingKey?: string;
        filterDataForGetActivities: Array<any>;
        coursePagefirstTwoTeachers: Array<any>;
        homePageSelectedTab: string;
        incomingActivities: Array<any>;
        incomingActivitiesIsLoaded: boolean;
        announcements: Array<any>;
        surveys: Array<any>;
        currentWeekActivities: Array<any>;
        courseContentsWeeks:
        Array<{
            notWeekly: boolean;
            notWeeklyName: string | null;
            termId: string | null;
            termWeekId: string | null;
            week: number | null;
            endDate: Date | null;
            startDate: Date | null;
            itemGuid: string;
            genaralActivity: boolean;
        }
        >;
        courseContentsWeeksLoading: boolean;
        courseContentWeekActivities: Array<
            {
                activityId: string;
                name: string;
                activityType: string;
                prerequisiteActivity: number;
                prerequisiteActivityName: string;
                termWeekId: string | null | undefined;
                totalCount: number;
                beginDate: any;
                endDate: any;
                activeStatus: number;
            }
        >;
        courseContentWeekActivitiesLoading: boolean;
        activeTabGuid: string | null;
        activityCard: IActivityCard;
        termWeeksOnFilter: Array<string> | null;
        activityFilters: IActivityFilters;
        sort: string;
        hasFilter: boolean;
        courseDefaultView: CourseDefaultViewType | null;
        courseContentActivityCardLoading: boolean;
        courseContentActivityCardRefresh: number;
        deleteActivityLoading: boolean;
        deletedActivityId: string;
        surveyChoices: Array<
            {
                questionId: string;
                groupId?: string;
                choiceId?: string;
                textualAnswer?: string;
                questionType: SurveyQuestionType;
            }
        >;
        activityCopy: Array<any>;
        activityMultiply: Array<any>;
        courseContentTermWeeks: Array<ICourseContentTermWeeks> | null;
        activityIdsByWeeks: Array<ICourseContentTermWeeks> | null;
        courseContentMenuLoading: boolean;
        courseContentMenuType: CourseContentMenuType | null;
        courseStudentList: {
            results: ICourseStudentListTabState | undefined;
            filters: IFilterStudent | null;
        };
        courseFiles: {
            results: Array<IFileView> | null;
            filters: IFilePagedQuery | null;
        };
        classActivityReport: IActivityStatsModel | null;
        assignmentGradeInformation: {
            gradeInformation: IAssignmentGradeInformationModel | null;
        };
        assignmentGradeStudentList: {
            results: Array<IAssignmentGradeStudentItem> | null;
            filters: IPagedQuery | null;
        };
        assignmentGradeSaveResult: {
            userID: string | null;
            classId: string | null;
            activityId: string | null;
            status: string | null;
        };
        myVirtualClass: Array<actionTypeVirtualClass.IMyVirtualClass> | null;
        myExams: Array<actionTypeExam.IMyExams> | null;
        myAssignments: Array<actionTypes.IMyAssignments> | null;
        myActivityStats: Array<IMyActivityStats> | null;
        myGrades: Array<actionTypeEnrollment.IMyGrades> | null;
        myMessages: any | null;
        progress: number;
        userMyClasses?: {
            results?: Array<{
                courseActiveStatus: number | null,
                className: string | null,
                classId: string | null,
                courseName: string | null,
                termName?: string | null,
                courseId: string | null,
                endDate?: Date | null,
                startDate?: Date | null,
                totalCount?: number | null,
                programName: string | null
            }> | null,
            filters: {
                total: number | null,
                page: number | null,
                take: number | null,
            } | null;
        } | null;
    };

    activityCopy: {
        courseActivityList: Array<
            {
                activityId: string | null;
                name: string | null;
                activityType: ActivityType | null;
                prerequisiteActivity: number | null;
                prerequisiteActivityName: string | null;
                isCommon: boolean | null;
                termWeekId: string | null;
                totalCount: number;
                beginDate: Date | null;
                endDate: Date | null;
            }
        >
        | null;
        termWeeks?: Array<
            {
                notWeekly: boolean;
                notWeeklyName: string | null;
                termId: string | null;
                termWeekId: string | null;
                week: number | null;
                endDate: Date | null;
                startDate: Date | null;
                itemGuid: string;
                genaralActivity: boolean;
            }
        >
        | null;
        copyResultData: {
            cloneActivityCount: number;
            activityType: ActivityTypeEnums | number;
            successCount: number;
            targetCourseID: string | null;
            errors: Array<any>;
            targetCourseName: string | null;
        } | null;
    };
    activityMultiply: {
        courseActivityList: Array<
            {
                activityId: string | null;
                name: string | null;
                activityType: ActivityType | null;
                prerequisiteActivity: number | null;
                prerequisiteActivityName: string | null;
                isCommon: boolean | null;
                termWeekId: string | null;
                totalCount: number;
                beginDate: Date | null;
                endDate: Date | null;
                actualStartTime: Date | null;
                actualEndTime: Date | null;
            }
        >;
        termWeeks?:
        Array<
            {
                notWeekly: boolean;
                notWeeklyName: string | null;
                termId: string | null;
                termWeekId: string | null;
                week: number | null;
                endDate: Date | null;
                startDate: Date | null;
                itemGuid: string;
                genaralActivity: boolean;
            }
        >;
        copyResultData: {
            cloneActivityCount: number;
            activityType: ActivityTypeEnums | number;
            successCount: number;
            targetCourseID: string | null;
            errors: Array<any>;
            targetCourseName: string | null;
        } | null;
        activityMultiplyDataList: {
            virtualClassTime: string | null;
            activityDuration: string | null;
        };
        multiplyResultData?: {
            success?: boolean | null;
        } | null;
        courseContentWeekActivities: Array<ICourseContentWeekActivitesBody>;
    };
    question: {
        QuestionDatas: {
            filters: IPagedQueryS;
            results: Array<actionTypeAddExamSession.IQuestions> | null;
        };
        QuestionData: actionTypeQuestion.IQuestionData;
        questionDifficulties: Array<{ label: string; value: string }>;
        multiQuestionFileUploadId: string;
        UploadMultiQuestionResults: IRefreshUploadMultiQuestionViewModel;
    };

    assignment: {
        AssignmentData: actionTypes.IAssignmentData;
        AssignmentType: actionTypes.AssignTypesEnums;
        AssignmentId: string;
        groupId: string;
        removedStudentDatas?: ISetAssignmentStudentList;
        assignedStudentDatas?: ISetAssignmentStudentList;
    };
    document: {
        DocumentData: actionTypeDocument.IDocumentData;
    };
    informationNote: {
        InformationNoteData: actionTypeInformationNote.IInformationNoteData;
    };
    exam: {
        ExamData: actionTypeExam.IExamData;
    };
    examSession: {
        sessionList: Array<actionTypeExamSession.IExamSessionList>;
        selectedSession: actionTypeExamSession.ISelectedExamSession;
        examSessionData: actionTypeExamSession.IExamSessionData;
        addQuestionDatas: {
            filters: IPagedQueryS;
            results: Array<actionTypeAddExamSession.IQuestions> | null;
        };
        isDefaultUpdateQuestion: number;
        addStudentDatas: {
            filters: IPagedQueryS;
            results: Array<actionTypeAddExamSession.IStudents> | null;
        };
        isDefaultUpdateStudent: number;
        questionDatas: {
            filters: IPagedQueryS;
            results: Array<actionTypeAddExamSession.IQuestions> | null;
        };
        studentDatas: {
            filters: IPagedQueryS;
            results: Array<actionTypeAddExamSession.IStudents> | null;
        };
        publishDatas: actionTypeAddExamSession.IPublishDatas;
        multiUsers: {
            results: Array<actionTypeAddExamSession.IMultiUsers> | null;
        };
    };
    calendar: {
        calendarDatas: Array<actionTypeCalendar.ICalendarData> | null;
    };
    project: {
        ProjectData: actionTypeProject.IProjectData;
        groups: Array<actionTypeProject.IGroupData> | null;
        lastCreatedGroupId: string | null;
    };
    link: {
        linkData: actionTypeLink.ILinkData;
    };
    survey: {
        surveyData: actionTypeSurvey.ISurveyData;
        homePageSurveys: Array<any>;
        selectedSurvey: any;
        selectedGeneralSurvey: {
            surveyInfoId: string,
            name: string,
            description: string,
            showOnStartUp: boolean,
            surveyType: number,
            surveyInfo: any,
        };
    };
    elesson: {
        elessonData: actionTypeElesson.IElessonData;
    };
    lti: {
        ltiData: actionTypeLti.ILtiData;
    };
    virtualClass: {
        VirtualClassData: actionTypeVirtualClass.IVirtualClassData;
        virtualClassPerculusUrl: string;
        VirtualClassType: any;
        VirtualClassId: string;
    };
    video: {
        videoData: actionTypeVideo.AssignData;
        questionData: actionTypeVideo.AssignQuestionData;
    };
    enrollment: {
        enrollmentData: Array<actionTypeEnrollment.IEnrollmentData>;
    };
    profile: {
        profileData: actionTypeProfile.AssignData;
        timezoneData: Array<actionTypeProfile.TimezoneData> | null,
        isChangePassword: boolean;
        isChangePasswordQuestion: boolean;
        isProfilePhotoUpload: boolean;
        photoKey: string | null;
        userPreferences: {
            preferences: Array<actionTypeProfile.IPreference>;
        };
    };
    reports: {
        DailyVisitorReport: {
            dailyVisitorGraphData: Array<actionTypeReport.IActiveUsersGraphData> | null;
            studentVisitorGraphData: Array<actionTypeReport.IActiveUsersGraphData> | null;
            activeStudentsData: Array<actionTypeReport.IActiveStudentsData> | null;
            totalVisitorsData: Array<actionTypeReport.IActiveUsersGraphData> | null;
            virtualClassSyncViewsData: Array<actionTypeReport.IActiveUsersGraphData> | null;
            virtualClassAsyncViewsData: Array<actionTypeReport.IActiveUsersGraphData> | null;
            frequentlyVisitedCoursesData: Array<actionTypeReport.IFrequentlyVisitedCoursesData> | null;
        };
    };

    qrPolling: {
        AttendanceData: ISetQrCodeForAttendance,
        QrCodeValue: string,
        AttendanceListData: {
            filters: IPagedQuery;
            results: Array<actionTypeQrPolling.IAttendanceDate> | null;
        };
        AttendanceUserListData: {
            filters: IPagedQuery;
            results: Array<actionTypeQrPolling.IAttendanceUserData> | null;
        },
        AttendanceCounts: {
            joinedStudentCount: number,
            notJoinedStudentCount: number,
            totalStudentCount: number
        },
        Classess: {
            results: Array<actionTypeQrPolling.IClassData> | null;
        }
        PollingData: IQrPollingData;
    };

    router: {
        action: string,
        location: {
            hash: string,
            key: string,
            pathname: string,
            query: { term_id: string, term_name: string },
            search: string,
            state: any
        }
    },
    announcement: {
        announcementData: Array<ILoginAnnouncementModel> | null | undefined;
        announcementIsLoaded: boolean;
        announcements: Array<any>;
        homePageAnnouncements: Array<any>,
        selectedAnnouncementIsLoaded: boolean;
        selectedAnnouncement: any;
        editAnnouncementData: IAnnouncement;
        announcementTake: number;
        announcementSkip: number;
        unreadCount: number;
        mainMenuAnnouncementUnread: boolean;
        unreadAnnounceCount: number;
        loginAnnouncementError: boolean;
    };
    userHomePage: {
        userHomeisNowThenPast: boolean,
        userHomeCalendarActivities: Array<IDashboardActivityItem> | null;
        userHomeCalendarIsLoading: boolean;
        userHomeCalendarTake: number;
        userHomeCalendarDateArray: Array<Date>;
        userHomeCalendarSkip: number;
        userHomeMyCourses:
        Array<
            {
                activeStatus: number | null;
                endDate: Date | null;
                logoUrl: string | null;
                name: string | null;
                progress: number;
                startDate: Date | null;
                Teachers: string | null;
                classId: string | null;
                courseId: string | null;
                isNotifications: number | null;
                newActivityCount: number | null;
                programId?: number | null;
                programName?: string | null;
                termId?: number | null;
                termName?: string | null;
                upcomingActivity: number | null;
                classCount?: number | null;
                starred: boolean;
                courseStartDate: Date | null;
                courseEndDate: Date | null;
            }
        >;
        userUpcomingActivities:
        Array<
            {
                ActivityType: ActivityType | null;
                Deadline: Date | null;
            }
        >;
        useHomeMyCoursesIsLoading: boolean;
        searchfilters: ICourseFilters | null
    };
    userPreference: {
        userPreferenceList: Array<{ code: string; value: string }>;
        userHomeAnnouncementList: Array<IUserHomeAnnouncementModel>;
    };
    users: {
        addModalSelectedData: {
            filters: userAddModalTypes.IFilterStudent | null;
            results: Array<userAddModalTypes.IStudentItem> | null;
        };
        addModalAllData: {
            filters: userAddModalTypes.IFilterStudent | null;
            results: Array<userAddModalTypes.IStudentItem> | null;
        };
    };
    message: {
        currentContextType: number | null | undefined;
        messages: Array<IMessage> | null | undefined;
        users: Array<IContact> | null | undefined;
        groups: Array<IGroup> | null | undefined;
        chatTitleImages: string | null | undefined;
        chatTitleText: string | null | undefined;
        chatTake: number;
        chatSkip: number;
        chatTotal: number;
        usersTake: number;
        usersSkip: number;
        groupsTake: number;
        groupsSkip: number;
        usersTotalCount: number;
        groupsTotalCount: number;
        currentContextId: string | null | undefined;
        currentContextType: number;
        originMessageId: string | null | undefined;
        userConversations: Array<IConversation> | null | undefined;
        groupConversations: Array<IConversation> | null | undefined;
        messageListTake: number;
        mainMenuMessageUnread: boolean;
        unreadMessageCount: number;
    };
    forum: {
        homePageConversation: Array<IConversation>;
        forumConversation: Array<IConversation>;
        forumTake: number;
        forumSkip: number;
        createAndEditData: ICreateForumData;
        forumMessages: Array<IForumMessage>;
        forumMessageTake: number;
        forumMessageSkip: number;
        forumMessageThreadId: string;
        forumMessageSubject: string;
        myGroup: Array<any>;
        forumData: actionTypeForum.AssignData;
        messageData: any;
    };
    helpDesk: {
        categories: Array<any>;
        status: Array<any>;
        helpDeskList: Array<any>;
        beginCreatedDate: Date;
        endCreatedDate: Date;
        helpDeskListTotalCount: number;
        helpDeskListPage: number,
        helpDeskListTake: number,
        helpDeskChat: Array<any>;
        id: string;
        HelpDeskStatusText: string;
        lastMessage: string;
        createdDate: string;
        chatTitleImages: string | null | undefined;
        helpTitle: string | null | undefined;
    };
    notification: {
        notifications: Array<INotification>;
        unreadNotificationCount: number;
        notificationsAll: Array<INotification>;
        unreadNotificationCountAll: number;
        activityNotifications: Array<INotification>;
        activityNotificationsAll: Array<INotification>;
        activityUnreadNotificationCountAll: number;
    };
    notificationAll: {
        notificationsAll: Array<INotification>;
        unreadNotificationCountAll: number;
    };
    activityNotifications: {
        activityNotifications: Array<INotification>;
        activityUnreadNotificationCount: number;
    };
    activityNotificationAll: {
        activityNotificationsAll: Array<INotification>;
        activityUnreadNotificationCountAll: number;
    };
    storageManagement: {
        storageManagementPage: Array<{
            fileSection: string,
            fileSize: number,
            totalFileSize: number,
            percentage: number
        }>;
        filesAddedActivitiesTermListPage: Array<{
            termId: string,
            termName: string,
            fileSize: number,
            totalFileSize: number,
            percentage: number
        }>;
        activityFilesStatisticsByTerm: Array<{
            termName: string,
            fileSize: number
        }>;
        activityFilesListByTerm: {
            results: Array<IAddedActivityFileView> | null;
            filters: IPagedQuery | null;
        };
        assignmentFilesListByTerm: {
            results: Array<IAddedAssignmentFileView> | null;
            filters: IPagedQuery | null;
        };
        deletedFilesListByTerm: {
            results: Array<IDeletedFileView> | null;
            filters: IPagedQuery | null;
        };
        communicationFilesList: {
            results: Array<any> | null;
            filters: IPagedQuery | null;
        }
        communicationFilesStatistics: Array<{
            termName: string,
            fileSize: number
        }>;
        personelFilesList: {
            results: Array<any> | null;
            filters: IPagedQuery | null;
        }
        otherFilesList: {
            results: Array<any> | null;
            filters: IPagedQuery | null;
        }
    };
    iFrame: {
        iFrameSource: any,
    };
    gradebook: {
        myGrades: Array<MyGrades> | null;
    };
    files: {
        myFiles: IMyFiles | null;
    }
}

export function GlobalState() {
    return {
        login: {
            login: {
                currentPage: '',
                trackingGuid: '',
                organizationId: 0,
                organizationName: '',
                headerText: '',
                footerText: '',
                logoPath: '',
                backgroundPath: '',
                organizationLogo: '',
                abbreviation: '',
                headerBackgroundImage: '',
                backgroundColor: '',
                forgotPasswordURLLink: '',
                requiresQuestionAndAnswer: false,
                forgotPasswordEnable: '',
                forgotMyPassword: {},
                forgotPasswordUrlRecover: '',
                haveUser: false,
                passwordSecurtiyQuestion: '',
                resetPasswordLoading: false,
                isQuestion: '',
                myForgotPasswordAnswerStatus: false,
                myForgotPasswordQuestionLoading: false,
                recoveryPasswordToken: '',
                notFoundToken: false,
                expiredToken: false,
                newPasswordLoading: false,
                minPasswordLength: 0,
                passwordStrength: '',
                alphaNumericLength: 0,
                newPasswordSaveStatus: 0,
                defaultCulture: '',
                forceChangePassword: false,
                minNonAlphanumericLength: 0,
                requisiteMinPasswordLength: 0,
                isAlmsPlusLoginPage: null,
                googleCaptchaSiteKey: '',
                isThereTwoFactorAuth: false,
                twoFactorEmail: ''
            },
            identitiy: {
                userId: '',
                username: '',
                firstName: '',
                lastName: '',
                fullName: '',
                isLogin: false,
                email: '',
                userName: '',
                userType: 8,
                loginPermission: Array<actionTypeEnrollment.IUserPermission>(),
                profileImagePath: '',
                isSimulate: false,
                customLoginPermission: Array<actionTypeEnrollment.IUserCustomPersmission>(),
                culture: '',
                clusterType: '',
                organizationId: 0,
                forceChangePassword: false,
                programName: '',
                timeZone:""
            },
            loginCulture: '',
            loginData: {
                username: '',
                password: '',
                loginCulture: '',
                googleCaptchaToken: '',
                loginToken: '',
                isExternal: false,
            },
            twoFactorVerificationError: '',
        },
        mainMenuRoot: {
            mainMenuIsLoading: false,
            timestamp: 0,
            type: '',
            mainMenu: Array<{ staticLink: '', name: '', url: '' }>(),
            courseSubNavigationTabParam: '',
            menuPanelItems: [{ name: '', type: 0 }],
            activityAddType: null,
            activityAddId: null,
            tabActiveStatus: 0,
            courseMenuPanelItemsIsLoaded: false,
            mainMenuCourseContent: Array<{
                teachers: '',
                name: '',
                logoUrl: '',
                progress: '',
                classId: '',
                courseId: '',
                endDate: '',
                startDate: ''
            }>(),
            mainMmenuCourseContentIsLoaded: false
        },
        coursePage: {
            classes: {
                coursePageActivityId: '',
                classes: []
            },
            isPassiveButton: false,
            isGettingWeeks: false,
            isShowActivityAdd: false,
            coursePageClassId: '',
            coursePageActivityId: '',
            actId: '',
            activityIdAfterAdd: '',
            ISetActivtyReportDetails: null,
            weekOrUnitId: '',
            coursePageclassInformation: null,
            lessonHeaderIsLoaded: false,
            activityProgressIsLoaded: false,
            announcementIsLoaded: false,
            currentWeekActivitiesIsLoaded: false,
            courseSortingKey: '-',
            activityProgressRecords: [],
            coursePagefirstTwoTeachers: [],
            isClickedWeek: false,
            getMoreActivities: false,
            resetShowMoreCount: false,
            homePageSelectedTab: '',
            incomingActivities: [],
            incomingActivitiesIsLoaded: false,
            announcements: [],
            currentWeekActivities: [],
            courseContentsWeeks: Array<{
                notWeekly: false,
                notWeeklyName: '',
                termId: '',
                termWeekId: '',
                week: 0,
                endDate: Date,
                startDate: Date,
                itemGuid: '',
                genaralActivity: false
            }>(),
            courseContentsWeeksLoading: false,
            courseContentWeekActivities: Array<{
                activityId: '',
                name: '',
                activityType: '',
                prerequisiteActivity: 0,
                prerequisiteActivityName: '',
                termWeekId: null,
                totalCount: 0,
                beginDate: null,
                endDate: null
            }>(),
            courseContentWeekActivitiesLoading: false,
            activeTabGuid: '',
            activityCard: {
                ActivityId: '',
                Name: '',
                Description: '',
                DateCriteria: 0,
                BeginDate: null,
                EndDate: null,
                SurveyId: '',
                DatePrerequisiteActivityId: '',
                DatePrerequisiteActivityHours: 0,
                PrerequisiteActivityId: '',
                isActivityPrerequisite: false,
                activityNameBoundWithPrerequisite: '',
                activityPrerequisiteCount: 0,
                activityPrerequisiteIds: '',
                AlwaysOnTop: false,
                SortOrder: 0,
                FileEmbed: '',
                IsTask: false,
                TaskDetail: '',
                TaskDeadLine: '',
                CompletionType: 0,
                CompletionCriteria: 0,
                IsCommon: false,
                ActivityType: null,
                ScorePercentage: 0,
                CourseId: '',
                StatViewPerUser: 0,
                StatViewRate: 0,
                ActualStartTime: null,
                ActualEndTime: null,
                CopyOfId: 0,
                CourseDefaultView: 1,
                CourseAllowSelfEnrollment: false,
                ActivityTypeId: 0,
                ExamQuestionCount: 0,
                ExamCategoryId: '',
                ExamIsRandomChoice: false,
                ExamIsRandomQuestion: false,
                ExamDurationInMinutes: 0,
                ExamQuestionDisplayType: 0,
                ExamPreMessage: '',
                ExamPostMessage: '',
                RepeatCount: 0,
                ExamRepeatCountInfinity: false,
                ExamScoringType: 0,
                ExamShowAnswerDateType: 0,
                ExamShowAnswerSpecifiedDate: null,
                ExamAllowMakeUpRequest: false,
                ShowQuestionScoreInExam: false,
                ExamQuestionWeightingType: 0,
                AllowStudentToSeeExamReport: false,
                VideoType: 0,
                Duration: 0,
                StatTotalSeconds: 0,
                StatAverageDuration: 0,
                AllowDownload: false,
                status: 0,
                SurveyAudience: 0,
                CollectResponsesForActiveCourses: false,
                AssignmentMaximumUploadCount: 0,
                AssignmentMaximumFileSize: 0,
                AssignmentGradeAnnouncementDate: null,
                AssignmentType: 0,
                AssignmentProjectType: 0,
                ELessonType: 0,
                VirtualClassType: 0,
                VirtualClassRemoteId: '',
                VirtualClassIsPacked: false,
                VirtualClassCultureCode: '',
                TotalVirtualClassDuration: 0,
                VirtualClassEnableReplayAfterFinish: true,
                VirtualClassParameters: '',
                Discriminator: '',
                Program_OrganizationalUnitId: 0,
                Thumbnail_FileId: 0,
                AllowActivityRating: false,
                AllowActivityWallComment: false,
                AllowDownloadAfterDeadline: false,
                CardImgName: '',
                activeStatus: 0,
                // File
                File: null,
                // Survey
                SurveyList: null,
                // Exam
                Exam: null,
                // Dictionary
                Dictionary: null
            },
            termWeeksOnFilter: [],
            activityFilters: {
                selectedActivityTypes: [],
                searchedText: '',
                sort: '-',
                hasFilter: false
            },
            sort: '-',
            hasFilter: false,
            courseDefaultView: null,
            courseContentActivityCardLoading: false,
            courseContentActivityCardRefresh: 0,
            deleteActivityLoading: false,
            deletedActivityId: null,
            surveyChoices: Array<{ questionId: '', groupId: '', choiceId: '', textualAnswer: '', questionType: null }>(),
            courseContentTermWeeks: Array<
                {
                    notWeekly: false,
                    notWeeklyName: null,
                    termId: null,
                    termWeekId: null,
                    week: null,
                    endDate: null,
                    startDate: null,
                    itemGuid: '',
                    genaralActivity: false
                }
            >(),
            courseContentMenuLoading: false,
            courseContentMenuType: null,
            courseStudentList: {
                studentList: null,
                filters: null
            },
            courseFiles: {
                results: null,
                filters: null
            },
            classActivityReport: {},
            assignmentGradeInformation: {},
            assignmentGradeStudentList: {
                filters: {},
                results: []
            },
            assignmentGradeSaveResult: {},
            myVirtualClass: null,
            myExams: null,
            myAssignments: null,
            myActivityStats: null,
            myGrades: null,
            myMessages: null,
            progress: null,
            userMyClasses: {
                results: Array<{
                    courseActiveStatus: 0,
                    className: '',
                    classId: '',
                    courseName: '',
                    termName: '',
                    courseId: '',
                    endDate: null,
                    startDate: null,
                    totalCount: 0,
                    programName: ''
                }>() | null,
                filters: {
                    total: 0,
                    page: 0,
                    take: 0,
                }
            },
        },
        activityCopy: {
            courseActivityList: Array<{
                activityId: '',
                name: '',
                activityType: null,
                prerequisiteActivity: 0,
                prerequisiteActivityName: '',
                isCommon: null,
                termWeekId: '',
                totalCount: 0,
                beginDate: null,
                endDate: null,
            }>(),
            termWeeks:
                Array<{
                    notWeekly: null,
                    notWeeklyName: '',
                    termId: '',
                    termWeekId: '',
                    week: 0,
                    endDate: null,
                    startDate: null,
                    itemGuid: '',
                    genaralActivity: null,
                }>(),
            copyResultData: {
                cloneActivityCount: 0,
                activityType: 0,
                successCount: 0,
                targetCourseID: '',
                errors: [],
                targetCourseName: '',
            }
        },
        activityMultiply: {
            courseActivityList: Array<{
                activityId: '',
                name: '',
                activityType: null,
                prerequisiteActivity: 0,
                prerequisiteActivityName: '',
                isCommon: null,
                termWeekId: '',
                totalCount: 0,
                beginDate: null,
                endDate: null,
                actualStartTime: null,
                actualEndTime: null,
            }>(),
            termWeeks: Array<{
                notWeekly: null,
                notWeeklyName: '',
                termId: '',
                termWeekId: '',
                week: 0,
                endDate: null,
                startDate: null,
                itemGuid: '',
                genaralActivity: null,
            }>(),
            copyResultData: {
                cloneActivityCount: 0,
                activityType: 0,
                successCount: 0,
                targetCourseID: '',
                errors: [],
                targetCourseName: '',
            },
            activityMultiplyDataList: {
                virtualClassTime: '',
                activityDuration: ''
            },
            multiplyResultData: {
                success: null
            } | null,
            courseContentWeekActivities: null
        },
        question: {
            QuestionDatas: {
                filters: {},
                results: []
            },
            QuestionData: {
                questionId: '',
                keywordIds: '',
                categoryIds: '',
                masterCourseIds: '',
                courseIds: '',
                termIds: '',
                topicIds: '',
                qestionCreatedDate: undefined,
                qestionUpdatedDate: undefined,
                questionType: -99,
                questionChoiceType: 0,
                questionText: '',
                questionComment: '',
                questionFile: '',
                questionFileId: '',
                questionDifficulty: '',
                fileUploadKey: '',
                choices: [],
                activeStatus: 1,
                isHtmlQuestion: true,
                isPublicQuestion: false,
                isExamQuestion: false
            },
            questionDifficulties: [],
            multiQuestionFileUploadId: '',
            UploadMultiQuestionResults: {
                totalQuestionsCount: 0,
                validQuestionsCount: 0,
                invalidQuestionsCount: 0,
                allQuestionTypeDistribution: undefined,
                validQuestionTypeDistribution: undefined,
                invalidQuestionTypeDistribution: undefined,
                wrongQuestionsFilePath: ''
            }
        },
        assignment: {
            AssignmentData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                note: 0,
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                completionType: 1,
                assignmentMaximumUploadCount: 5,
                assignmentMaximumFileSize: 1024,
                alwaysOnTop: false,
                dateCriteria: 0,
                allowDownload: false,
                activitytype: '1',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                resourceType: 0,
            },
            // addAssignmentStatus: false,
            AssignmentType: null,
            AssignmentId: '',
            groupId: ''
        },
        announcement: {
            announcementData: null,
            announcementIsLoaded: false,
            announcements: [],
            homePageAnnouncements: [],
            selectedAnnouncement: null,
            selectedAnnouncementIsLoaded: false,
            editAnnouncementData: {
                targets: [],
                content: '',
                smsContent: '',
                fileUploadKey: '',
                isSms: false,
                isEmail: false,
                isNotification: false,
                isPin: false,
                isShowOnStartUp: false,
                announcementId: '',
                subject: '',
                alwaysOnTop: false,
                notificationContent: ''
            },
            announcementTake: 5,
            announcementSkip: 0,
            unreadCount: 0,
            mainMenuAnnouncementUnread: false,
            unreadAnnounceCount: 0,
            loginAnnouncementError: false
        },
        document: {
            DocumentData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                note: 0,
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                completionType: 1,
                alwaysOnTop: false,
                dateCriteria: 0,
                allowDownload: false,
                activitytype: '1',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                documentActivityType: ActivityTypeEnums.Document
            }
        },
        informationNote: {
            InformationNoteData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                alwaysOnTop: true,
                dateCriteria: 0,
                allowDownload: false,
                activitytype: '1',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                informationNoteActivityType: ActivityTypeEnums.InformationNote
            }
        },
        elesson: {
            elessonData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                note: 0,
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                completionType: 1,
                alwaysOnTop: false,
                dateCriteria: 0,
                allowDownload: false,
                activitytype: '1',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                elessonType: 0
            }
        },
        exam: {
            ExamData: {
                isUpdate: false,
                dateCriteria: 0,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                note: 0,
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                completionType: 3,
                alwaysOnTop: false,
                activitytype: '5',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                examPreMessage: '',
                examPostMessage: '',
                repeatCount: 1,
                examRepeatCountInfinity: false,
                examCategoryId: '',
                examEntryDateType: ExamEntryDateType.LoginWithinGivenTime, // CustomProperty2
                examScoringType: ExamScoringType.LastAttempt,
                examQuestionWeights: [],
                isRandomChoice: true,
                isRandomQuestion: true,
                autoEnroll: true,
            }
        },
        examSession: {
            sessionList: [],
            selectedSession: {},
            examSessionData: {
                autoEnroll: true,
                examScoringType: ExamScoringType.LastAttempt
            },
            addQuestionDatas: {
                filters: {},
                results: []
            },
            isDefaultUpdateQuestion: 1,
            addStudentDatas: {
                filters: {},
                results: [],
            },
            isDefaultUpdateStudent: 1,
            questionDatas: {
                filters: {},
                results: []
            },
            studentDatas: {
                filters: {},
                results: []
            },
            publishDatas: {
                isQuestionGraterThanZero: 0,
                isAvaible: 0,
                isPassive: 0,
                isSessionQuestionCountGraterEqualThanExamQuestionCount: 0,
                isValidSessionDates: 0,
                sessionEndDateIsNotExpired: 0,
                isStudentGraterThanZero: 0,
                prePopulateCount: 0,
                examUserCount: 0,
                isWeightingOk: 0,
            },
            multiUsers: {
                results: [],
            }

        },
        calendar: {
            calendarDatas: []
        },
        project: {
            ProjectData: {
                isUpdate: false,
                isGroupProject: true,
                groupAddType: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                note: 0,
                allUnits: false,
                selectUnits: [],
                subActivities: [],
                groupList: [],
                remainingUsers: 0,
                selectCondition: [],
                selectOwner: [],
                completionType: 1,
                alwaysOnTop: false,
                dateCriteria: 0,
                selectedClass: [],
                allowDownload: true,
                activitytype: '1',
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: ''
            },
            groups: null,
            lastCreatedGroupId: null
        },
        link: {
            linkData: {
                name: '',
                description: '',
                isCommon: 0,
                dateCriteria: 0,
                termWeekIds: [],
                datePrerequisiteActivityId: '',
                completionType: ActivityCompletionType.View,
                allUnits: false,
                selectedActivityUnitsTagIds: [],
                prerequisiteActivityId: '',
                alwaysOnTop: false,
                selectedActivityOwnersTagIds: [],
                fileInputKey: '',
                customProperty3: '0',
                customProperty4: '',
                url: ''
            }
        },
        survey: {
            surveyData: {
                name: '',
                description: '',
                isCommon: 0,
                dateCriteria: 0,
                termWeekIds: [],
                datePrerequisiteActivityId: '',
                completionType: ActivityCompletionType.Complete,
                allUnits: false,
                selectedActivityUnitsTagIds: [],
                prerequisiteActivityId: '',
                alwaysOnTop: false,
                selectedActivityOwnersTagIds: [],
                fileInputKey: '',
                activityType: '10',
                surveyInfo: undefined
            },
            homePageSurveys: [],
            selectedSurvey: null,
            selectedGeneralSurvey: {
                surveyInfoId: '',
                name: '',
                description: '',
                showOnStartUp: false,
                surveyType: 0,
                surveyInfo: null,
            },
        },
        virtualClass: {
            VirtualClassData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                completionCriteria: ActivityCompletionType.None,
                note: 0,
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                preparationTime: '15',
                virtualClassTime: '60',
                virtualClassEnableReplayAfterFinish: true,
                actualStartTime: '',
                actualEndTime: '',
                selectOwner: [],
                completionType: 8,
                alwaysOnTop: false,
                dateCriteria: 0,
                selectedClass: [],
                allowDownload: false,
                activitytype: '1',
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: ''
            },
            virtualClassPerculusUrl: null,
            VirtualClassId: ''
        },
        video: {
            videoData: {
                name: '',
                description: '',
                isCommon: 0,
                taskDeadline: '',
                dateCriteria: 0,
                termWeekIds: [],
                datePrerequisiteActivityId: '',
                activityCompletionType: 1,
                completionType: 1,
                allUnits: false,
                selectedActivityUnitsTagIds: [],
                prerequisiteActivityId: '',
                alwaysOnTop: false,
                videoType: 0,
                selectedActivityOwnersTagIds: [],
                fileInputKey: ''
            },
            questionData: {
                activityId: '',
                questions: []
            }
        },
        profile: {
            profileData: null,
            timezoneData: null,
            isChangePassword: false,
            isChangePasswordQuestion: false,
            isProfilePhotoUpload: false,
            photoKey: Guid.create().toString(),
            userPreferences: {
                preferences: Array<actionTypeProfile.IPreference>()
            }
        },
        reports: {
            DailyVisitorReport: {
                dailyVisitorGraphData: null,
                studentVisitorGraphData: null,
                activeStudentsData: null,
                frequentlyVisitedCoursesData: null,
                totalVisitorsData: null,
                virtualClassSyncViewsData: null,
                virtualClassAsyncViewsData: null
            }
        },
        qrPolling: {
            AttendanceData: {
                attendanceId: null,
                attendanceGuid: null,
                attendanceExpirationDate: null
            },
            QrCodeValue: null,
            AttendanceListData: {
                filters: {},
                results: []
            },
            AttendanceUserListData: {
                filters: {},
                results: []
            },
            AttendanceCounts: {
                joinedStudentCount: 0,
                notJoinedStudentCount: 0,
                totalStudentCount: 0,
            },
            Classess: {
                results: []
            },
            PollingData: {
                isCommon: 0
            }
        },
        router: {
            action: '',
            location: {
                hash: "",
                key: "",
                pathname: "",
                query: { term_id: '', term_name: '' },
                search: "",
                state: null
            }
        },
        enrollment: {
            enrollmentData: Array<actionTypeEnrollment.IEnrollmentData>()
        },
        users: {
            addModalSelectedData: {
                filters: {},
                results: []
            },
            addModalAllData: {
                filters: {},
                results: []
            }
        },
        userHomePage: {
            userHomeisNowThenPast: false,
            userHomeCalendarActivities: Array<{
                dueDate: null,
                activityId: '',
                classId: '',
                courseName: '',
                activityName: '',
                courseId: '',
                activityType: '',
                startDate: null,
                endDate: null
            }>(),
            userHomeCalendarIsLoading: false,
            userHomeCalendarTake: 0,
            userHomeCalendarSkip: 0,
            userHomeCalendarDateArray: [],
            userHomeMyCourses: Array<{
                activeStatus: 0,
                endDate: null,
                logoUrl: '',
                name: '',
                progress: 0,
                startDate: null,
                Teachers: '',
                classId: '',
                courseId: '',
                isNotifications: 0,
                programId: 0,
                programName: '',
                termId: 0,
                termName: '',
                newActivityCount: 0,
                classCount: 0,
                starred: false,
                courseStartDate: null,
                courseEndDate: null
            }>(),
            useHomeMyCoursesIsLoading: false,
            searchfilters: null
        },
        userPreference: {
            userPreferenceList: Array<IUserPreferenceModel>(),
            userHomeAnnouncementList: Array<IUserHomeAnnouncementModel>()
        },
        message: {
            chatTitleImages: '',
            chatTitleText: '',
            messages: [],
            chatTake: 10,
            chatSkip: 0,
            chatTotal: 0,
            currentContextId: undefined,
            currentContextType: 0,
            originMessageId: null,
            users: [],
            usersTotalCount: 0,
            usersTake: 0,
            usersSkip: 0,
            groupsTake: 0,
            groupsSkip: 0,
            groupsTotalCount: 0,
            groups: [],
            userConversations: [],
            groupConversations: [],
            messageListTake: 3,
            mainMenuMessageUnread: false,
            unreadMessageCount: 0
        },
        forum: {
            homePageConversation: null,
            forumConversation: null,
            forumTake: 0,
            forumSkip: 0,
            createAndEditData: {
                isCommon: true,
                subject: '',
                body: '',
                isModerated: false,
                courseId: '',
                classIds: [],
                forumThreadId: ''
            },
            forumMessages: [],
            forumMessageTake: 0,
            forumMessageSkip: 0,
            forumMessageThreadId: '',
            forumMessageSubject: '',
            myGroup: null,
            forumData: {
                name: '',
                description: '',
                firstForumMessage: '',
                isCommon: 0,
                taskDeadline: '',
                dateCriteria: 0,
                termWeekIds: [],
                datePrerequisiteActivityId: '',
                completionType: ActivityCompletionType.View,
                allUnits: false,
                selectedActivityUnitsTagIds: [],
                prerequisiteActivityId: '',
                alwaysOnTop: false,
                selectedActivityOwnersTagIds: [],
                fileInputKey: ''
            } as actionTypeForum.AssignData,
            messageData: {
                threadId: '',
                messageId: '',
                message: ''
            }
        },
        lti: {
            ltiData: {
                isUpdate: false,
                isCommon: 0,
                name: '',
                description: '',
                filterActivityView: 'criterionDate',
                dateRange: '',
                selectActivity: [],
                allUnits: false,
                selectUnits: [],
                selectCondition: [],
                selectOwner: [],
                completionType: 1,
                alwaysOnTop: false,
                dateCriteria: 0,
                activitytype: '1',
                selectedClass: [],
                selectWeek: [],
                termWeekIds: [],
                activityTime: 0,
                selectedActivityUnitsTagIds: [],
                selectedActivityOwnersTagIds: [],
                prerequisiteActivityId: '',
                datePrerequisiteActivityId: '',
                ltiId: ''
            }
        },
        helpDesk: {
            helpDeskList: [],
            helpDeskChat: [],
            helpTitle: '',
            helpDeskListPage: 1,
            helpDeskListTake: 10,
            helpDeskListTotalCount: 0,
        },
        notification: {
            notifications: [],
            unreadNotificationCount: 0,
            notificationsAll: [],
            unreadNotificationCountAll: 0,
            activityNotifications: [],
            activityNotificationsAll: [],
            activityUnreadNotificationCountAll: 0
        },

        notificationAll: {
            notificationsAll: [],
            unreadNotificationCountAll: 0
        },

        activityNotificationAll: {
            activityNotificationsAll: [],
            activityUnreadNotificationCountAll: 0
        },
        activityNotifications: {
            activityNotifications: [],
            activityUnreadNotificationCount: 0
        },
        storageManagement: {
            storageManagementPage: Array<{
                fileSection: "",
                fileSize: 0,
                totalFileSize: 0,
                percentage: 0
            }>(),
            filesAddedActivitiesTermListPage: Array<{
                termId: "",
                termName: "",
                fileSize: 0,
                totalFileSize: 0,
                percentage: 0
            }>(),
            activityFilesStatisticsByTerm: Array<{
                termName: "",
                fileSize: 0
            }>(),
            activityFilesListByTerm: {
                results: null,
                filters: null
            },
            assignmentFilesListByTerm: {
                results: null,
                filters: null
            },
            deletedFilesListByTerm: {
                results: null,
                filters: null
            },
            communicationFilesList: {
                results: null,
                filters: null
            },
            communicationFilesStatistics: Array<{
                termName: "",
                fileSize: 0
            }>(),
            personelFilesList: {
                results: null,
                filters: null
            },
            otherFilesList: {
                results: null,
                filters: null
            },
        },
        iFrame: {
            iFrameSource: null,
        },
        gradebook: {
            myGrades: []
        },
        files: {
            myFiles: null
        }
    };
}
/* End of App States */
